module.exports = __webpack_public_path__ + "img/banner_mobile_JP.3535dc70.png";